export default __webpack_public_path__ + "static/media/flowcharthelp.82e60ccc.png";